var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Logo Icons",
    filter: "url(#filter0_d_142_50985)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Box",
    cx: 34,
    cy: 30,
    r: 24,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Logo"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 29.52C18 20.6023 24.9867 14 34 14C43.0133 14 50 20.6023 50 29.52C50 38.4378 43.0133 45.0401 34 45.0401C32.3811 45.0401 30.8278 44.8263 29.3685 44.425C29.0848 44.3469 28.7831 44.369 28.5139 44.4877L25.3381 45.8897C24.5074 46.2564 23.5697 45.6657 23.5419 44.7578L23.4547 41.9117C23.444 41.561 23.2862 41.2333 23.0249 40.9994C19.9117 38.2153 18 34.1846 18 29.52ZM29.0921 26.6021L24.3921 34.0588C23.941 34.7744 24.8206 35.5808 25.4945 35.0694L30.543 31.2379C30.8845 30.9787 31.3565 30.9773 31.6994 31.2346L35.4377 34.0382C36.5594 34.8796 38.1603 34.5842 38.908 33.398L43.608 25.9413C44.0589 25.2257 43.1794 24.4193 42.5055 24.9306L37.457 28.7621C37.1154 29.0213 36.6435 29.0227 36.3005 28.7654L32.5624 25.9618C31.4406 25.1205 29.8397 25.4159 29.0921 26.6021Z",
    fill: "url(#paint0_linear_142_50985)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_142_50985",
    x: 0,
    y: 0,
    width: 68,
    height: 68,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_142_50985"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_142_50985",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_142_50985",
    x1: 34,
    y1: 14,
    x2: 34,
    y2: 46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#053CC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#042A8D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMes);
export default __webpack_public_path__ + "static/media/mes.2e87e8417dd06dc5756f12e00d15a869.svg";
export { ForwardRef as ReactComponent };